import { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom'; // Reserved for future navigation
import BlogList from '../components/BlogList';
import { blogService } from '../services/apiService';

const Blogs = () => {
  // const navigate = useNavigate(); // Reserved for future navigation
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const LIMIT = 10; // 10 items per page

  const fetchBlogs = async (pageNumber = page) => {
    try {
      setLoading(true);
      setError('');
      const response = await blogService.getBlogs({ page: pageNumber, limit: LIMIT });
      if (response && response.data) {
        setBlogs(response.data || []);
        setTotalPages(response.pagination?.total || 1);
      } else if (Array.isArray(response)) {
        setBlogs(response);
        setTotalPages(1);
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch blogs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs(page);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  if (loading) {
    return <div className="text-center py-8">Loading blogs...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Blog Management</h2>
      <BlogList blogs={blogs} fetchBlogs={fetchBlogs} />
      <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-600">Page {page} of {totalPages}</div>
        <div className="space-x-2">
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className={`px-3 py-1 rounded bg-white border ${page === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}>
            Prev
          </button>
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className={`px-3 py-1 rounded bg-white border ${page === totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Blogs;